import axios from "axios";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import { BbotModal, Form } from "top-component-library";
import NumberInput from "top-component-library/form-inputs/NumberInput";
import { generalErrorAlert } from "util/Utils";

const EditCardModal = (props) => {
  const { visible, onCancel, onSuccess, paymentMethod, customerId } = props;
  const [isSaving, setIsSaving] = useState(false);

  const [editCardForm] = Form.useForm();

  const now = DateTime.now();

  useEffect(() => {
    editCardForm.setFieldsValue({
      expirationMonth: paymentMethod?.card?.exp_month,
      expirationYear: paymentMethod?.card?.exp_year,
    });
  }, [editCardForm, paymentMethod]);

  const saveCardDetails = async (values) => {
    setIsSaving(true);
    try {
      const payload = {
        customer_id: customerId,
        payment_method_id: paymentMethod.id,
        exp_month: values.expirationMonth,
        exp_year: values.expirationYear,
      };
      await axios.post("api/updatePaymentMethod", payload);
      onSuccess();
    } catch (error) {
      generalErrorAlert(error, "Could not update card information.");
    }
    setIsSaving(false);
  };

  return (
    <BbotModal
      visible={visible}
      onCancel={onCancel}
      okText={"Save"}
      okButtonProps={{
        htmlType: "submit",
        form: "edit-card",
        loading: isSaving,
      }}
      title={`Edit Credit Expiration (Card Ending in ${paymentMethod?.card?.last4})`}
    >
      <Form
        form={editCardForm}
        name={"edit-card"}
        onFinish={saveCardDetails}
        layout={"vertical"}
        initialValues={{
          expirationMonth: paymentMethod?.card?.exp_month,
          expirationYear: paymentMethod?.card?.exp_year,
        }}
      >
        <NumberInput
          label={"Expiration Month"}
          name={"expirationMonth"}
          required
          rules={[
            {
              type: "number",
              min: 1,
              message: "Please enter a valid month.",
            },
            {
              type: "number",
              max: 12,
              message: "Please enter a valid month.",
            },
          ]}
        />
        <NumberInput
          label={"Expiration Year"}
          name={"expirationYear"}
          required
          rules={[
            {
              type: "number",
              min: now.year,
              message: "Please enter a non-expired date.",
            },
          ]}
        />
      </Form>
    </BbotModal>
  );
};

export default EditCardModal;
